import React from 'react';
import styled from 'styled-components';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import { AIReview } from '../../../common/models/types';
import AIReviewDetailTemplate from '../AIReviewDetailTemplate';
import { SlideManager } from '../../organisms/CommonUI/SlidePopup/SlideManager';
import AIReviewDetailAdminViewerTemplate from '../AIReviewDetailTemplate/AdminViewer';

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f5f5;
`;

const Header = styled.div`
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

const ReviewInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #666;
`;

const ReviewLabel = styled.span`
  font-weight: 500;
  color: #4A90E2;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  padding: 4px 8px;
  
  &:hover {
    color: #333;
  }
`;

const ContentContainer = styled.div`
  flex: 1;
  overflow: hidden;
  background: #f5f5f5;
`;

const StyledPanelGroup = styled(PanelGroup)`
  height: 100%;
`;

const StyledPanel = styled(Panel)`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const StyledPanelResizeHandle = styled(PanelResizeHandle)`
  width: 8px;
  background: #e5e7eb;
  cursor: col-resize;
  position: relative;
  
  &:hover {
    background: #d1d5db;
  }
  
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 2px;
    height: 30px;
    background: #9ca3af;
    border-radius: 1px;
  }
`;

const PanelContent = styled.div`
  flex: 1;
  overflow: hidden;
  position: relative;
`;

interface AdminAIReviewCompareTemplateProps {
  leftReview: AIReview;
  rightReview: AIReview;
}

const AdminAIReviewCompareTemplate: React.FC<AdminAIReviewCompareTemplateProps> = ({ 
  leftReview, 
  rightReview 
}) => {
  const handleClose = () => {
    window.close();
  };

  // Admin 상세 데이터 보기 핸들러
  const handleShowLeftAdminDetail = () => {
    SlideManager.show({
      body: <AIReviewDetailAdminViewerTemplate review={leftReview} onDeleteReview={() => {}} />,
      width: "800px",
    });
  };

  const handleShowRightAdminDetail = () => {
    SlideManager.show({
      body: <AIReviewDetailAdminViewerTemplate review={rightReview} onDeleteReview={() => {}} />,
      width: "800px",
    });
  };

  return (
    <Container>
      <Header>
        <HeaderLeft>
          <Title>AI 리뷰 비교</Title>
          <ReviewInfo>
            <ReviewLabel>리뷰 #{leftReview.id}</ReviewLabel>
            <span>vs</span>
            <ReviewLabel>리뷰 #{rightReview.id}</ReviewLabel>
          </ReviewInfo>
        </HeaderLeft>
        <CloseButton onClick={handleClose}>✕</CloseButton>
      </Header>
      
      <ContentContainer>
        <StyledPanelGroup direction="horizontal">
          <StyledPanel defaultSize={50} minSize={30}>
            <PanelContent>
              <AIReviewDetailTemplate 
                review={leftReview} 
                hideHeader={true}
                isCompareMode={true}
                onAdminDetail={handleShowLeftAdminDetail}
              />
            </PanelContent>
          </StyledPanel>
          
          <StyledPanelResizeHandle />
          
          <StyledPanel defaultSize={50} minSize={30}>
            <PanelContent>
              <AIReviewDetailTemplate 
                review={rightReview}
                hideHeader={true}
                isCompareMode={true}
                onAdminDetail={handleShowRightAdminDetail}
              />
            </PanelContent>
          </StyledPanel>
        </StyledPanelGroup>
      </ContentContainer>
    </Container>
  );
};

export default AdminAIReviewCompareTemplate;